import React from "react"
import { Group, Source } from "@mui/icons-material"
import { Scopes } from "utils/authUtils"
import { USER_ROLE } from "./application"


export const USER_ROLE_FILTERS = {
  all: 'Todas',
  compliance: 'Compliance',
  hr: 'Recursos Humanos',
  admin: 'Administrador',
  adminReadOnly: 'Apenas Leitura',
}

export const USER_ROLE_DESCRIPTION = {
  [USER_ROLE.hr]: 'Pode ver e decidir sobre apontamentos derivados para o time de Recursos Humanos.', 
  [USER_ROLE.compliance]: 'Pode ver e decidir sobre apontamentos derivados para o time de Compliance.', 
  [USER_ROLE.admin]: 'Pode ver e decidir sobre apontamentos das áreas de Recursos Humanos e Compliance.',
  [USER_ROLE.adminReadOnly]: 'Pode ver os apontamentos das áreas de Recursos Humanos e Compliance, mas não pode tomar decisões.', 
}

export const USER_PERMISSION = {
  [Scopes.OPTIONS_MANAGEMENT]: 'Gerenciar Base de Opções Restritivas',
  [Scopes.USER_MANAGEMENT]: 'Gerenciar Acesso de Usuários',
}

export const getUserPermissionIcon = (scope, fontSize = 'medium') => {
  const icons = {
    [Scopes.OPTIONS_MANAGEMENT]: <Source fontSize={fontSize}/>,
    [Scopes.USER_MANAGEMENT]: <Group fontSize={fontSize} />,
  }
  return icons[scope]
}
